import React from 'react';
import { Image } from 'semantic-ui-react';
import { Images } from '../../style';

export const EmbeddedLogo = ({ show, className }) => show && (
  <a
    href="https://videopeel.com/"
    target="_blank"
    className={`float-right ${className}`}
  >
    Verified by
    <Image className="embeddLogo" src={Images.embeddLogo} size='' />
  </a>
);



// WEBPACK FOOTER //
// ./src/components/EmbeddedLogo/EmbeddedLogo.js